import { render, staticRenderFns } from "./praticien.vue?vue&type=template&id=92113426&scoped=true&"
import script from "./praticien.vue?vue&type=script&lang=js&"
export * from "./praticien.vue?vue&type=script&lang=js&"
import style0 from "./praticien.vue?vue&type=style&index=0&id=92113426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92113426",
  null
  
)

export default component.exports